import { render, staticRenderFns } from "./AnswersPicker.vue?vue&type=template&id=27469922&scoped=true&"
import script from "./AnswersPicker.vue?vue&type=script&lang=js&"
export * from "./AnswersPicker.vue?vue&type=script&lang=js&"
import style0 from "./AnswersPicker.vue?vue&type=style&index=0&id=27469922&lang=sass&scoped=true&"
import style1 from "./AnswersPicker.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27469922",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VRadio,VRadioGroup,VTextarea})
